/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import alertComponents from "../components/Alarm/AlertComponents";
import { useTranslate } from "../hooks/LanguageProvider";
import SelectReport from "../components/Vehicle/SelectReport";
import { Form } from "react-bootstrap";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams, Link } from "react-router-dom";
import usePermissions from '../hooks/usePermissions';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface Dispositif {
    id: string;
    value: string;
}

interface AlarmInterface {
    id_alarme: string;
    id_user?: string;
    items: Dispositif[];
    alarm_type: number;
    id_type_alarme: number;
    alarm_metrics: string;
    alarm_name: string;
    id_alarm_group: number;
    date_creation?: string;
    date_modification?: string;
    name_groupe_alarme: string;
    id_groupe_alarme: number;
}

interface Vehicle {
    immatriculation_vehicule: string;
    id_dispositif: number;
}

interface Driver {
    nom_conducteur: string;
    prenom_conducteur: string;
    id_conducteur: number;
}

const Alarm: React.FC = () => {
    const [step, setStep] = useState(1);
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const { id_alarme } = useParams<{ id_alarme?: string }>();
    const [loading, setLoading] = useState(true);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [inputTypeSearchValue, setTypeSearchValue] = useState<number>(11);
    const [inputTypeSearchLabel, setTypeSearchLabel] = useState<string>(
        translate("Matriculation")
    );
    const [inputAdvanceSearch, setInputAdvancedSearch] =
        useState<string>("Vehicle");
    const [InputAdvanceSearchGroup, setInputAdvancedSearchGroup] =
        useState<string>("Group");
    const [itemsAlerts, setItemsAlerts] = useState<{ value: any; id: any }[]>([]);
    const [SelectReportState, setSelectReportState] = useState(false);
    const [SelectGroupState, setSelectGroupState] = useState(false);
    const [SearchByIcon, setSearchByIcon] = useState("filter");
    const [autocompleteStateIcon, setAutocompleteStateIcon] = useState("search");
    let [alarmFor, setAlarmFor] = useState("Vehicles");
    let [itemSearch, setItemSearch] = useState("");
    let [itemGroupSearch, setItemGroupSearch] = useState("");
    let [itemGroupName, setItemGroupName] = useState("");
    const id_user = localStorage.getItem("userid");
    const [autocompleteState, setAutocompleteState] = useState("");
    const [autocompleteGroupState, setAutocompleteGroupState] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [alarmSuggestions, setAlarmSuggestions] = useState([]);
    const [checkboxStates, setCheckboxStates] = useState<{
        [key: string]: boolean;
    }>({});
    const [selectAll, setSelectAll] = useState(false);
    const [createButtonDisabled, setCreateButtonDisabled] = useState(false);
    const [groupsOptions, setGroupsOptions] = useState<any[]>([
        { value: "Aucun", label: "Aucun" },
    ]);
    const [group, setGroups] = useState<any[]>();

    const [Alarm, setAlarm] = useState<AlarmInterface>({
        id_user: id_user ?? undefined,
        id_alarme: id_alarme ?? "0",
        items: [],
        alarm_type: 0,
        id_type_alarme: 0,
        alarm_metrics: "",
        alarm_name: "",
        id_alarm_group: 0,
        name_groupe_alarme: "",
        id_groupe_alarme: 0,
    });


    const roleId = localStorage.getItem("id_role");


    const { userPermissions } = usePermissions(roleId);


    function mapPermissionIdToReportId(permissionId: number): number | null {
        const mapping: Record<number, number> = {
            88: 2,
            89: 3,
            90: 4,
            91: 5,
            92: 6,
            93: 7,
            94: 8,
            95: 9,
            96: 10,
            97: 11,
            98: 12,
            99: 13,
            100: 14,
            101: 15,
            102: 16,
            103: 17,
            104: 18,
            105: 19,
            106: 20,
            107: 21,
            108: 22,
            109: 23,
            110: 24,
            111: 25,
            112: 26,
            113: 27,
            114: 28,
            115: 29,
            116: 30,
            117: 31,
            118: 32,
            119: 33,
            120: 34,
            121: 35,
            122: 36,
            123: 37,
            124: 38,
            125: 39,
            126: 40,
            127: 41,
            128: 42,
            129: 43,
            130: 44,
            131: 45,
            132: 46,
            133: 47,
            134: 48,
            135: 49,
            136: 50
        };

        return mapping[permissionId] ?? null;
    }



    const allAlarmsData: { [key: number]: string } = {
        88: translate("Outside POI during forbidden time"),
        89: translate("No transmission"),
        90: translate("Accelerometer alarm (device)"),
        91: translate("iButton authentication alarm (device)"),
        92: translate("GPS jamming alarm (device)"),
        93: translate("GSM jamming alarm (device)"),
        94: translate("CAN alarm (device)"),
        95: translate("SIM credit alarm"),
        96: translate("iButton group alarm (device)"),
        97: translate("I/O alarm"),
        98: translate("Private mode alarm (device)"),
        99: translate("Specific iButton alarm (device)"),
        100: translate("Power interruption"),
        101: translate("Battery discharged (device)"),
        102: translate("Motion sensor (device)"),
        103: translate("Date/Time"),
        104: translate("Speed violation (device)"),
        105: translate("iButton error (device)"),
        106: translate("Ignition status (device)"),
        107: translate("Relay status (device)"),
        108: translate("Panic status (device)"),
        109: translate("Event counter EV1 increment"),
        110: translate("Event counter EV2 increment"),
        111: translate("Garmin interface or screen disconnected (device)"),
        112: translate("Engine started during forbidden time"),
        113: translate("Movement with engine off (device)"),
        114: translate("Memory full (device)"),
        115: translate("GPS signal level"),
        116: translate("GSM signal level"),
        117: translate("Number of resets"),
        118: translate("CAN odometer"),
        119: translate("GPS odometer"),
        120: translate("Points of interest"),
        121: translate("Relay activated"),
        122: translate("Relay disconnected (device)"),
        123: translate("CAN engine speed"),
        124: translate("Unknown GSM network"),
        125: translate("Invalid GPS signal (device)"),
        126: translate("Under-voltage (device)"),
        127: translate("Idling with engine on"),
        128: translate("Idling with engine on (device)"),
        129: translate("Vehicle parked with engine off (device)"),
        130: translate("Over-voltage (device)"),
        131: translate("CAN engine temperature"),
        132: translate("Daily mobile traffic (device)"),
        133: translate("Monthly mobile traffic (device)"),
        134: translate("Speed"),
        135: translate("POI Entry/Exit"),
        136: translate("POI Speed Violation")
    };


    const alarmsData: { [key: number]: string } = Object.fromEntries(
        userPermissions
            .map((perm) => mapPermissionIdToReportId(perm.id_permission)) // ✅ corrige ici
            .filter((id): id is number => id !== null)
            .map((id) => [id, allAlarmsData[id]])
    );


    const addAlarmParams = () => {
        // Add logic here to go to the next step and load the alarm settings
        setStep(2);
    };

    const wizardBack = () => {
        setStep(step - 1);
    };

    const checkStep3 = () => {
        // Add logic here to check form fields from step 3
        console.log("Checking step 3");
    };

    //Alerts components
    const [selectedAlarm, setSelectedAlarm] = useState<number | null>(null);

    const handleAlarmTypeChange = (typeAlert: string) => {
        const value = parseInt(typeAlert, 10);
        setSelectedAlarm(value !== 0 ? value : null);
        console.log(value + "=" + Alarm.id_type_alarme);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_metrics:
                value === Alarm.id_type_alarme
                    ? Alarm.alarm_metrics
                    : createEmptyMetrics(value),
            alarm_type: value,
        }));
    };

    const createEmptyMetrics = (alarmType: number): any => {
        switch (alarmType) {
            case 2:
                return {
                    type: "PoiAlarm",
                    ids:
                        Alarm.id_type_alarme == 2
                            ? JSON.parse(Alarm.alarm_metrics).ids
                            : [],
                };
            case 3:
                return {
                    type: "AbsenceOfTransmission",
                    hour:
                        Alarm.id_type_alarme == 3
                            ? JSON.parse(Alarm.alarm_metrics).hours
                            : 0,
                };
            case 4:
                return {
                    type: "AccelerometreAlarm",
                };
            case 5:
                return {
                    type: "AuthentificationButtonAlarm ",
                };
            case 6:
                return {
                    type: "BrouillageGPSAlarm",
                };
            case 7:
                return {
                    type: "BrouillageGSMAlarm",
                };
            case 8:
                return {
                    type: "CANAlarm",
                };
            case 9:
                return {
                    type: "SIMCreditAlarm",
                    credit_Threshold:
                        Alarm.id_type_alarme == 9
                            ? JSON.parse(Alarm.alarm_metrics).credit_Threshold
                            : 200, // Valeur par défaut, peut être une chaîne vide
                };
            case 10:
                return {
                    type: "GroupeButtonAlarm",
                };
            case 11:
                return {
                    type: "I/O Alarm",
                };
            case 12:
                return {
                    type: "PrivateModeAlarm",
                };
            case 13:
                return {
                    type: "specificButtonAlarm",
                };
            case 14:
                return {
                    type: "powerAlarm ",
                    powerDisconnected:
                        Alarm.id_type_alarme == 14
                            ? JSON.parse(Alarm.alarm_metrics).powerDisconnected
                            : 0, // Valeur par défaut, peut être une chaîne vide
                };
            case 15:
                return {
                    type: "BatteryAlarm ",
                    batteryThreshold:
                        Alarm.id_type_alarme == 15
                            ? JSON.parse(Alarm.alarm_metrics).BatteryAlarm
                            : 50, // Valeur par défaut, peut être une chaîne vide
                };
            case 16:
                return {
                    type: "MotionSensor",
                };
            case 17:
                return {
                    type: "DateTimeAlarm",
                    datetime:
                        Alarm.id_type_alarme == 17
                            ? JSON.parse(Alarm.alarm_metrics).datetime
                            : 0, // Valeur par défaut, peut être une chaîne vide
                };
            case 18:
                return {
                    type: "SpeedExceedAlarm",
                    speed_limit:
                        Alarm.id_type_alarme == 18
                            ? JSON.parse(Alarm.alarm_metrics).speed_limit
                            : 90, // Valeur par défaut, peut être une chaîne vide
                };
            case 19:
                return {
                    type: "ButtonErreur  ",
                };
            case 20:
                return {
                    type: "Motor Contact Status",
                };
            case 21:
                return {
                    type: "RelayStatus",
                };
            case 22:
                return {
                    type: "Panic state",
                };

            case 23: // IncrementCounterEV1
                return {
                    type: "IncrementCounterEV1",
                    //        counter_value: Alarm.id_type_alarme == 23 ? JSON.parse(Alarm.alarm_metrics).counter_value : 0 // Default value
                };
            case 24:
                return {
                    type: "IncrementCounterEV2",
                };
            case 25: // InterfaceOrGarminScreenDisconnected
                return {
                    type: "InterfaceOrGarminScreenDisconnected",
                };
            case 26: // EngineStartedDuringRestrictedTime
                return {
                    type: "EngineStartedDuringRestrictedTime",
                };
            case 27: // MovementWithEngineOff
                return {
                    type: "MovementWithEngineOff",
                };
            case 28: // MemoryFull
                return {
                    type: "MemoryFull",
                };
            case 29:
                return {
                    type: "GPSSignalAlarm ",
                    threshold:
                        Alarm.id_type_alarme == 29
                            ? JSON.parse(Alarm.alarm_metrics).threshold
                            : 50, // Valeur par défaut, peut être une chaîne vide
                };
            case 30:
                return {
                    type: "GsmSignalAlarm ",
                    threshold:
                        Alarm.id_type_alarme == 30
                            ? JSON.parse(Alarm.alarm_metrics).threshold
                            : 50, // Valeur par défaut, peut être une chaîne vide
                };
            case 31:
                return {
                    type: "ResetAlarm ",
                    threshold:
                        Alarm.id_type_alarme == 31
                            ? JSON.parse(Alarm.alarm_metrics).threshold
                            : 0, // Valeur par défaut, peut être une chaîne vide
                };
            case 32: // OdometerCAN
                return {
                    type: "OdometerCAN",
                    threshold:
                        Alarm.id_type_alarme == 32
                            ? JSON.parse(Alarm.alarm_metrics).threshold
                            : 1000, // Default value
                };
            case 33: // OdometerGPS
                return {
                    type: "OdometerGPS",
                    threshold:
                        Alarm.id_type_alarme == 33
                            ? JSON.parse(Alarm.alarm_metrics).threshold
                            : 2000, // Default value
                };
            case 34: //PointsOfInterest
                return {
                    type: "PointsOfInterest",
                };
            case 35: // RelayActivated
                return {
                    type: "RelayActivated",
                };
            case 36: // RelayDisconnected
                return {
                    type: "RelayDisconnected",
                };
            case 37: // EngineSpeedCAN
                return {
                    type: "EngineSpeedCAN",
                    rpm_threshold:
                        Alarm.id_type_alarme == 37
                            ? JSON.parse(Alarm.alarm_metrics).rpm_threshold
                            : 3000, // Default value
                };
            case 38: // UnknownGSMNetwork
                return {
                    type: "UnknownGSMNetwork",
                };
            case 39: // InvalidGPSSignal
                return {
                    type: "InvalidGPSSignal",
                };
            case 40: // UnderVoltage
                return {
                    type: "UnderVoltage",
                    undervoltage_threshold:
                        Alarm.id_type_alarme == 40
                            ? JSON.parse(Alarm.alarm_metrics).undervoltage_threshold
                            : 11.5, // Default value
                };
            case 41: // StationaryWithEngineOn
                return {
                    type: "StationaryWithEngineOn",
                };
            case 42: // StationaryWithEngineOnDevice
                return {
                    type: "StationaryWithEngineOnDevice",
                };
            case 43: // ParkingWithEngineOff
                return {
                    type: "StationaryWithEngineOff",
                };
            case 44: // OverVoltage
                return {
                    type: "OverVoltage",
                    overvoltage_threshold:
                        Alarm.id_type_alarme == 44
                            ? JSON.parse(Alarm.alarm_metrics).overvoltage_threshold
                            : 15.0, // Default value
                };
            case 45: // EngineTemperatureCAN
                return {
                    type: "EngineTemperatureCAN",
                    temperature_threshold:
                        Alarm.id_type_alarme == 45
                            ? JSON.parse(Alarm.alarm_metrics).temperature_threshold
                            : 95, // Default value
                };
            case 46: // DailyMobileData
                return {
                    type: "DailyMobileData",
                    daily_data_limit_mb:
                        Alarm.id_type_alarme == 46
                            ? JSON.parse(Alarm.alarm_metrics).daily_data_limit_mb
                            : 500, // Default value
                };
            case 47: // MonthlyMobileData
                return {
                    type: "MonthlyMobileData",
                    monthly_data_limit_mb:
                        Alarm.id_type_alarme == 47
                            ? JSON.parse(Alarm.alarm_metrics).monthly_data_limit_mb
                            : 10000, // Default value
                };
            case 48: // SpeedAlarm
                return {
                    type: "SpeedAlarm",
                    max_speed:
                        Alarm.id_type_alarme == 48
                            ? JSON.parse(Alarm.alarm_metrics).max_speed
                            : 80, // Vous pouvez initialiser à 0 ou une valeur par défaut
                };

            case 49: //   POI Entry/Exit
                return {
                    type: "POIEntryExit",
                    ids:
                        Alarm.id_type_alarme == 49
                            ? JSON.parse(Alarm.alarm_metrics).ids
                            : [], // Liste vide pour les identifiants // Vous pouvez initialiser à 0 ou une valeur par défaut
                };

            case 50: // POI Speed Violation
                return {
                    type: "POISpeedViolation",
                    max_speed:
                        Alarm.id_type_alarme == 50
                            ? JSON.parse(Alarm.alarm_metrics).max_speed
                            : 80,
                    ids:
                        Alarm.id_type_alarme == 50
                            ? JSON.parse(Alarm.alarm_metrics).ids
                            : [], // Liste vide pour les identifiants // Vous pouvez initialiser à 0 ou une valeur par défaut
                };

            default:
                return {}; // By default, returns an empty object.
        }
    };

    const updateMetrics = (newMetrics: any) => {
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_metrics: newMetrics,
        }));
    };

    const handleAlarmMetricsChange = (newMetrics: any) => {
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_metrics: newMetrics,
        }));
    };

    // In the render method of the Alarm component
    let AlarmComponent =
        selectedAlarm !== null && alertComponents[selectedAlarm]
            ? React.createElement(alertComponents[selectedAlarm], {
                alarm: Alarm.alarm_metrics,
                onChange: handleAlarmMetricsChange,
            })
            : null;

    const [searchTypeOptions, setSearchTypeOptions] = useState([
        { value: "11", label: "Matriculation" },
        { value: "12", label: "PSN" },
        { value: "14", label: "Vehicle group" },
        { value: "15", label: "User" },
    ]);

    const addReportBy = async (type: string) => {
        if (type == "1") {
            setAlarmFor("Vehicles");
        } else {
            setAlarmFor("Drivers");
        }

        try {
            setLoading(true);

            const res = await fetch(`${backendUrl}/api/search/report-for/${type}`, {
                mode: "cors",
            });
            const data = await res.json();

            const optionsArray = data["data"][0]["searchfor"].split(",");
            setSearchTypeOptions(
                optionsArray.map((option: any, index: any) => ({
                    value: type.toString() + (index + 1).toString(),
                    label: translate(option.trim()),
                }))
            );

            setTypeSearchValue(parseInt(type.toString() + "1"));
            console.log("Autocomplete: " + type);

            setTypeSearchLabel(translate(optionsArray[0]));
            setInputAdvancedSearch(translate(optionsArray[0]));

            setItemsAlerts([]);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const searchBy = async (option: any) => {
        setInputAdvancedSearch(translate(option.label));
        setTypeSearchLabel(translate(option.label));
        setTypeSearchValue(option.value);
        setItemsAlerts([]);
    };

    const getAutocomplete = async (search: string) => {
        setItemSearch(search);
        setAutocompleteState("");
        setAutocompleteStateIcon("spinner");

        try {
            if (search.trim() !== "") {
                const res = await fetch(
                    `${backendUrl}/api/search/${inputTypeSearchValue}/${search}/${id_user}`,
                    { mode: "cors" }
                );
                const data = await res.json();

                const getSuggestions = data.data.map((item: any) => {
                    let newItem: any = {};

                    if (inputTypeSearchValue == 11 || inputTypeSearchValue == 34) {
                        newItem.value = item.immatriculation_vehicule;
                        newItem.id = item.id_dispositif;
                    } else if (inputTypeSearchValue == 12) {
                        newItem.value = item.psn_dispositif;
                        newItem.id = item.id_dispositif;
                    } else if (inputTypeSearchValue == 14) {
                        newItem.value = item.nom_groupe;
                        newItem.id = item.id_groupe;
                    } else if (inputTypeSearchValue == 15) {
                        newItem.value = item.username_user;
                        newItem.id = item.id_user;
                    } else if (inputTypeSearchValue == 31 || inputTypeSearchValue == 51) {
                        newItem.value = item.nom_conducteur + " " + item.prenom_conducteur;
                        newItem.id = item.id_dispositif;
                    } else if (inputTypeSearchValue == 33) {
                        newItem.value = item.nom;
                        newItem.id = item.id_agence;
                    } else if (inputTypeSearchValue == 32) {
                        newItem.value = item.username_user;
                        newItem.id = item.id_user;
                    }

                    return newItem;
                });

                setSuggestions(getSuggestions);
                setAutocompleteStateIcon("search");

                getSuggestions.forEach((item: { value: any }) => {
                    updateCheckboxState(item.value);
                });
            } else {
                setAutocompleteStateIcon("search");
                setSuggestions([]);
            }
        } catch (error) {
            setAutocompleteStateIcon("search");
            setSuggestions([]);
        }
    };

    const getGroupsAlarm = async (name_groupe: string) => {
        setItemGroupSearch(name_groupe);
        setAutocompleteGroupState("");
        setAutocompleteStateIcon("spinner");

        try {
            const bodyData = JSON.stringify({
                id_user,
                name_groupe,
            });

            const groupsData = await fetch(`${backendUrl}/api/alarm/group-options`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: bodyData,
                mode: "cors",
            });

            const data = await groupsData.json();

            const groupsOptionsData = data.map((group: any) => ({
                value: group.id_groupe_alarme,
                label: `${group.name_groupe_alarme || ""}`,
            }));

            setGroupsOptions(groupsOptionsData);
            setAlarmSuggestions(groupsOptionsData);
        } catch (error) {
            setAlarmSuggestions([]);
        }
    };
    const handleSelectAllChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const { checked } = event.target;

        // Update the state for "select all"
        setSelectAll(checked);

        // Update the checkbox states
        const updatedCheckboxStates: { [key: string]: boolean } = {};
        itemsAlerts.forEach((item: any) => {
            updatedCheckboxStates[item.value] = checked;
        });
        setCheckboxStates(updatedCheckboxStates);

        // Build the list of selected alarms
        const selectedAlarms: Dispositif[] = itemsAlerts.map((item) => ({
            id: item.id.toString(), // Convert to string if necessary
            value: item.value.toString(), // Convert to string if necessary
        }));

        // Update the alarm state
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            items: selectedAlarms, // Update the list of alarms
        }));

        // Check if any alarms are selected to enable/disable the "Create" button
        setIsCreateButtonDisabled(selectedAlarms.length == 0);

        console.log(selectedAlarms);
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked, id } = event.target; // Get the checkbox element's ID (unique)

        setCheckboxStates((prevState) => ({
            ...prevState,
            [name]: checked,
        }));

        const updatedCheckboxStates = {
            ...checkboxStates,
            [name]: checked,
        };

        // Check if at least one checkbox is selected
        const anySelected = Object.values(updatedCheckboxStates).some(
            (value) => value
        );
        setIsCreateButtonDisabled(!anySelected);

        // Create the list of selected alarms, ensuring that the ID and value are correctly defined
        const selectedAlarms: Dispositif[] = Object.keys(updatedCheckboxStates)
            .filter((key) => updatedCheckboxStates[key]) // Filter the selected checkboxes
            .map((key) => {
                // Ensure you are taking the correct ID here (the ID of the selected item)
                const item = itemsAlerts.find((item) => item.value === key); // Find the corresponding alarm
                return {
                    id: item ? item.id : "", // Use the specific ID of the alarm
                    value: key,
                };
            });

        // Update the alarm state with the correct structure
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            items: selectedAlarms, // Update items with Dispositif[]
            id_alarme: prevAlarm.id_alarme,
            alarm_type: prevAlarm.alarm_type,
            id_type_alarme: prevAlarm.id_type_alarme,
            alarm_metrics: prevAlarm.alarm_metrics,
            alarm_name: prevAlarm.alarm_name,
            id_alarm_group: prevAlarm.id_alarm_group,
            name_groupe_alarme: prevAlarm.name_groupe_alarme,
        }));

        console.log(selectedAlarms); // Check the data after update
    };

    // const setItems = async (newItem: any) => {
    //     const itemExists = itemsAlerts.some((item) => item.value === newItem.value);

    //     if (!itemExists) {
    //         const updatedItemsAlarms = [...itemsAlerts, newItem];
    //         setItemsAlerts(updatedItemsAlarms);

    //         setAlarm(prevAlarm => ({
    //             ...prevAlarm,
    //             items: updatedItemsAlarms
    //         }));

    //         setAutocompleteState("autocomplete-state");
    //         setItemSearch(newItem.value);
    //         handleAlarmSelect(updatedItemsAlarms);
    //         updateCheckboxState(newItem);

    //     } else {
    //         setAutocompleteState("autocomplete-state");
    //         alert("The item already exists in the list...");
    //         console.log("The item already exists in the list..");
    //     }

    // };

    const getAutocompleteVehicle = async (id_user: number) => {
        setItemSearch("");
        setAutocompleteState("");
        try {
            const res = await fetch(`${backendUrl}/api/search/vehicle`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    id_user: id_user,
                }),
            });

            const data = await res.json();

            const getSuggestions = data.map((item: any) => {
                let newItem: any = {};

                newItem.value = item.immatriculation_vehicule;
                newItem.id = item.id_dispositif;

                return newItem;
            });

            setItemsAlerts(getSuggestions);

            getSuggestions.forEach((item: { value: any }) => {
                //// console.log(item.value);

                updateCheckboxState(item.value);
            });

            setAutocompleteState("");

            return getSuggestions;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const getAutocompleteVehicleByGroup = async (id_groupe: number) => {
        setItemSearch("");
        setAutocompleteState("");
        try {
            const res = await fetch(`${backendUrl}/api/search/group-vehicles`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    id_groupe: id_groupe,
                }),
            });

            const data = await res.json();

            const getSuggestions = data.map((item: any) => {
                let newItem: any = {};
                newItem.value = item.immatriculation_vehicule;
                newItem.id = item.id_dispositif;

                return newItem;
            });

            setItemsAlerts(getSuggestions);

            getSuggestions.forEach((item: { value: any }) => {
                updateCheckboxState(item.value);
            });

            setAutocompleteState("");

            return getSuggestions;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const getAutocompleteDriversByIdUser = async (id_user: number) => {
        //setItemSearch("");
        setAutocompleteState("");
        try {
            const res = await fetch(`${backendUrl}/api/search/drivers`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    id_user: id_user,
                }),
            });

            const data = await res.json();

            // console.log(data)

            const getSuggestions = data.map((item: any) => {
                let newItem: any = {};

                newItem.value = item.nom_conducteur + " " + item.prenom_conducteur;
                newItem.id = item.id_conducteur;

                return newItem;
            });

            setItemsAlerts(getSuggestions);

            getSuggestions.forEach((item: { value: any }) => {
                //// console.log(item.value);

                updateCheckboxState(item.value);
            });

            setAutocompleteState("");

            return getSuggestions;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const updateAllCheckboxState = (newItems: { value: string }[]) => {
        const updatedCheckboxStates = { ...checkboxStates };

        newItems.forEach((item) => {
            updatedCheckboxStates[item.value] = true; // Cocher tous les items
        });

        setCheckboxStates(updatedCheckboxStates);
    };

    const setItems = async (newItem: any) => {
        if (inputTypeSearchValue != 14 && inputTypeSearchValue != 15) {
            const itemExists = itemsAlerts.some(
                (item) => item.value === newItem.value
            );
            if (!itemExists) {
                const updatedItemsReports = [...itemsAlerts, newItem];
                setItemsAlerts(updatedItemsReports);
                setAutocompleteState("autocomplete-state");
                setItemSearch(newItem.value);
                //onVehicleSelect(updatedItemsReports);
                updateCheckboxState(newItem);
            } else {
                setAutocompleteState("autocomplete-state");
                // console.log("The item already exists in the list.");
            }
        }

        if (inputTypeSearchValue == 15) {
            // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
            const allVehicle = await getAutocompleteVehicle(newItem.id);
            setItemSearch(newItem.value);
            setAutocompleteState("autocomplete-state");
            const idDevices = allVehicle.map((item: Vehicle) => item.id_dispositif);
            // onVehicleSelect(idDevices);
            updateCheckboxState(newItem);
        }

        if (inputTypeSearchValue == 14) {
            // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
            const allVehicle = await getAutocompleteVehicleByGroup(newItem.id);
            setItemSearch(newItem.value);
            setAutocompleteState("autocomplete-state");
            const idDevices = allVehicle.map((item: Vehicle) => item.id_dispositif);
            //  onVehicleSelect(idDevices);

            updateCheckboxState(newItem);
        }

        if (inputTypeSearchValue == 32) {
            // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
            const allDriver = await getAutocompleteDriversByIdUser(newItem.id);
            setItemSearch(newItem.value);
            setAutocompleteState("autocomplete-state");
            const idDrivers = allDriver.map((item: Driver) => item.id_conducteur);
            // onVehicleSelect(idDrivers);

            const formattedItems = allDriver.map((item: Driver) => ({
                value: `${item.nom_conducteur} ${item.prenom_conducteur}`,
            }));

            updateAllCheckboxState(formattedItems);
        }
    };

    const [isCreateButtonDisabled, setIsCreateButtonDisabled] =
        useState<boolean>(true);

    const handleAlarmSelect = (alarms: { value: any; id: any }[]) => {
        setItemsAlerts(alarms);
        setIsCreateButtonDisabled(alarms.length === 0);
    };

    const handleAlarmGroupChange = (newIdAlarmGroup: any) => {
        setItemGroupSearch(newIdAlarmGroup.label);
        setAutocompleteGroupState("autocomplete-state");
        console.log(newIdAlarmGroup.value);
        console.log(newIdAlarmGroup.label);

        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            id_groupe_alarme: newIdAlarmGroup.value,
            name_groupe_alarme: newIdAlarmGroup.label,
        }));

        console.log(Alarm);
    };

    const handleAlarmNameChange = (newIdAlarmName: string) => {
        setItemGroupName(newIdAlarmName);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_name: newIdAlarmName,
        }));

        console.log(Alarm);
    };

    const updateCheckboxState = (newItem: { value: any }) => {
        const updatedCheckboxStates = { ...checkboxStates };
        updatedCheckboxStates[newItem.value] = true; // Mark as selected
        setCheckboxStates(updatedCheckboxStates);
    };

    const createAlarm = async () => {
        try {
            console.log("Form submitted", Alarm);

            const response = await fetch(`${backendUrl}/api/alarm/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id_user: Alarm.id_user,
                    items: Alarm.items,
                    alarm_metrics: Alarm.alarm_metrics,
                    alarm_name: Alarm.alarm_name,
                    alarm_type: Alarm.alarm_type,
                    id_groupe_alarme: Alarm.id_groupe_alarme,
                }),
                mode: "cors",
            });

            const alarmResponse = await response.json();
            console.log(alarmResponse);

            toast.success(translate("Alarm create successfully"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            navigate("/alarms");

            // Handle the response as needed here
        } catch (error) {
            toast.warn(translate("Can't create Alarm"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            console.error("Error creating alarm:", error);
            // Handle errors as needed here
        }
    };

    const updateAlarm = async () => {
        try {
            console.log("Alarm form submitted", Alarm);

            const response = await fetch(`${backendUrl}/api/alarm/update`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id_alarme: Alarm.id_alarme,
                    id_user: Alarm.id_user,
                    items: Alarm.items,
                    alarm_metrics: Alarm.alarm_metrics,
                    alarm_name: Alarm.alarm_name,
                    alarm_type: Alarm.alarm_type,
                    id_groupe_alarme: Alarm.id_groupe_alarme,
                }),
                mode: "cors",
            });

            const alarmResponse = await response.json();
            console.log(alarmResponse);

            toast.success(translate("Alarm update successfully"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            navigate("/alarms");

            // Handle the response as needed here
        } catch (error) {
            toast.warn(translate("Can't update alarm"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            console.error("Error update alarm:", error);
            // Handle errors as needed here
        }
    };

    const getAlarm = async () => {
        try {
            const res = await fetch(`${backendUrl}/api/alarm/find/${id_alarme}`, {
                mode: "cors",
            });

            if (!res.ok) {
                console.error("Error retrieving alarm");
                return;
            }

            const data = await res.json();
            setAlarm({
                id_alarme: data.id_alarme,
                alarm_name: data.alarm_name,
                name_groupe_alarme: data.name_groupe_alarme,
                id_user: data.id_user,
                items: data.items,
                alarm_metrics: data.alarm_metrics,
                alarm_type: data.alarm_type,
                id_groupe_alarme: data.id_groupe_alarme,
                id_type_alarme: data.id_type_alarme,
                id_alarm_group: data.id_alarm_group,
            });

            console.log({
                id_alarme: data.id_alarme,
                alarm_name: data.alarm_name,
                name_groupe_alarme: data.name_groupe_alarme,
                id_user: data.id_user,
                items: data.items,
                alarm_metrics: data.alarm_metrics,
                alarm_type: data.alarm_type,
                id_groupe_alarme: data.id_alarm_group,
                id_type_alarme: data.id_type_alarme,
                id_alarm_group: data.id_alarm_group,
            });

            // Update the list and checkboxes
            setItemsAlerts(data.items);
            const initialCheckboxStates: { [key: string]: boolean } = {};
            data.items.forEach((item: { value: any }) => {
                initialCheckboxStates[item.value] = true; // Automatically check
            });
            setCheckboxStates(initialCheckboxStates);

            // Disable or enable the button depending on the elements
            setIsCreateButtonDisabled(data.items.length === 0);

            // Mise à jour des noms et types
            setItemGroupName(data.name_alarme);
            setItemGroupSearch(data.name_groupe_alarme);
            setSelectedAlarm(data.id_type_alarme.toString());
            handleAlarmTypeChange(data.id_type_alarme.toString());

            // Update specific metrics
            if ([2, 3, 48, 49, 50].includes(data.id_type_alarme)) {
                updateMetrics(JSON.parse(data.alarm_metrics));
            }
        } catch (error) {
            console.error("Error retrieving alarm", error);
        }
    };

    useEffect(() => {
        if (id_alarme) {
            getAlarm();
            console.log(Alarm);
        }
    }, []); //

    const alarmOptions = [
        { value: "0", label: "-" },
        { value: "2", label: "Outside POI during forbidden time" },
        { value: "3", label: "No transmission" },
        { value: "4", label: "Accelerometer alarm (device)" },
        { value: "5", label: "iButton authentication alarm (device)" },
        { value: "6", label: "GPS jamming alarm (device)" },
        { value: "7", label: "GSM jamming alarm (device)" },
        { value: "8", label: "CAN alarm (device)" },
        { value: "9", label: "SIM credit alarm" },
        { value: "10", label: "iButton group alarm (device)" },
        { value: "11", label: "I/O alarm" },
        { value: "12", label: "Private mode alarm (device)" },
        { value: "13", label: "Specific iButton alarm (device)" },
        { value: "14", label: "Power interruption" },
        { value: "15", label: "Battery discharged (device)" },
        { value: "16", label: "Motion sensor (device)" },
        { value: "17", label: "Date/Time" },
        { value: "18", label: "Speed violation (device)" },
        { value: "19", label: "iButton error (device)" },
        { value: "20", label: "Ignition status (device)" },
        { value: "21", label: "Relay status (device)" },
        { value: "22", label: "Panic status (device)" },
        { value: "23", label: "Event counter EV1 increment" },
        { value: "24", label: "Event counter EV2 increment" },
        { value: "25", label: "Garmin interface or screen disconnected (device)" },
        { value: "26", label: "Engine started during forbidden time" },
        { value: "27", label: "Movement with engine off (device)" },
        { value: "28", label: "Memory full (device)" },
        { value: "29", label: "GPS signal level" },
        { value: "30", label: "GSM signal level" },
        { value: "31", label: "Number of resets" },
        { value: "32", label: "CAN odometer" },
        { value: "33", label: "GPS odometer" },
        { value: "34", label: "Points of interest" },
        { value: "35", label: "Relay activated" },
        { value: "36", label: "Relay disconnected (device)" },
        { value: "37", label: "CAN engine speed" },
        { value: "38", label: "Unknown GSM network" },
        { value: "39", label: "Invalid GPS signal (device)" },
        { value: "40", label: "Under-voltage (device)" },
        { value: "41", label: "Idling with engine on" },
        { value: "42", label: "Idling with engine on (device)" },
        { value: "43", label: "Vehicle parked with engine off (device)" },
        { value: "44", label: "Over-voltage (device)" },
        { value: "45", label: "CAN engine temperature" },
        { value: "46", label: "Daily mobile traffic (device)" },
        { value: "47", label: "Monthly mobile traffic (device)" },
        { value: "48", label: "Speed" },
        { value: "49", label: "POI Entry/Exit" },
        { value: "50", label: "POI Speed Violation" },
    ];

    return (
        <>
            <div id="content">
                <div id="add_alarm_wizard" className="wizard">
                    <ul className="steps">
                        <li
                            data-target="#step1"
                            className={step === 1 ? "active-step" : ""}
                        >
                            <span className="badge badge-info">1</span>{" "}
                            {translate("Alarm for")} <span className="chevron"></span>
                        </li>
                        <li className="ml-2 mr-2">
                            <i className="las la-exchange-alt"></i>
                        </li>
                        <li
                            data-target="#step2"
                            className={step === 2 ? "active-step" : ""}
                        >
                            <span className="badge badge-info">2</span>{" "}
                            {translate("Settings")}
                            <span className="chevron"></span>
                        </li>
                    </ul>
                </div>
                <div className="">
                    <form id="add_alarm_form" style={{ width: "100%" }}>
                        <input type="hidden" name="step" value={step} />
                        {step === 1 && (
                            <div
                                className="step-pane-bgr step-pane active panel panel-default"
                                id="step1"
                                style={{ marginTop: "5px", padding: "15px" }}
                            >
                                <div className="panel-body">
                                    <div className="row">
                                        <div
                                            className="col-md-4 col-sm-4"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <div
                                                className="input-group-addon input-sm"
                                                style={{ paddingRight: "15px", paddingTop: "3px" }}
                                            >

                                                {id_alarme
                                                    ? translate("Update alarm for")
                                                    : translate("Add alarm for")
                                                }

                                            </div>
                                            <div className="d-flex align-items-center">
                                                <i
                                                    className={`las la-file-alt icon-report search-icon`}
                                                    style={{ padding: "0px 5px", color: "#fff" }}
                                                />
                                                <select
                                                    id="add_report_for"
                                                    name="add_report_for"
                                                    onChange={(e) => addReportBy(e.target.value)}
                                                    className="form-control input-sm"
                                                >
                                                    <option value="1">{translate("Vehicles")}</option>
                                                    <option value="3">{translate("Drivers")}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div
                                            className="col-md-4 col-sm-4"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <SelectReport
                                                controlId="category_vehicule"
                                                label={translate("Search by") + translate("Type")}
                                                icon={SearchByIcon}
                                                options={searchTypeOptions}
                                                valueType={{
                                                    value: inputTypeSearchValue,
                                                    label: translate(inputTypeSearchLabel),
                                                }}
                                                onChange={searchBy}
                                                disabled={SelectReportState}
                                            />
                                        </div>
                                        <div
                                            className="col-md-4 col-sm-4"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <div
                                                className="input-group-addon input-sm"
                                                style={{ paddingRight: "15px", paddingTop: "3px" }}
                                            >
                                                {translate("Search by")}{" "}
                                            </div>
                                            <div>
                                                <div style={{ position: "relative" }}>
                                                    <div className="d-flex align-items-center">
                                                        <i
                                                            className={`las la-${autocompleteStateIcon} icon-report`}
                                                            style={{ padding: "0px 5px" }}
                                                        />
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={`${translate(inputAdvanceSearch)}`}
                                                            className="me-2"
                                                            aria-label={`${translate(inputAdvanceSearch)}`}
                                                            onChange={(e) => getAutocomplete(e.target.value)}
                                                            value={itemSearch}
                                                            disabled={SelectReportState}
                                                        />
                                                    </div>
                                                    <div
                                                        className={`autocomplete-items ${autocompleteState}`}
                                                        style={{ listStyleType: "none", padding: 0 }}
                                                    >
                                                        {suggestions &&
                                                            suggestions.map(
                                                                (suggestion: any, index: number) => (
                                                                    <div
                                                                        key={index}
                                                                        onClick={(e) => setItems(suggestion)}
                                                                    >
                                                                        <p id={suggestion.id}>
                                                                            {" "}
                                                                            {suggestion.value}
                                                                        </p>
                                                                    </div>
                                                                )
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12" style={{ marginTop: "15px" }}>
                                            <div className="row" style={{ marginBottom: "15px" }}>
                                                <div className="col-md-12">
                                                    <div
                                                        className=""
                                                        style={{
                                                            padding: "3px 9px",
                                                            border: "1px solid #ccc",
                                                            borderBottom: "0px",
                                                        }}
                                                    >
                                                        <input
                                                            id="mf_cb"
                                                            name="selectAll"
                                                            type="checkbox"
                                                            checked={selectAll}
                                                            onChange={handleSelectAllChange}
                                                        />
                                                        <span id="mf_title" style={{ fontWeight: "bold" }}>
                                                            {" "}
                                                            <span id="nbrofvehicule">
                                                                ({itemsAlerts.length})
                                                            </span>
                                                            {translate(alarmFor)}
                                                        </span>
                                                    </div>
                                                    <div
                                                        className="table-responsive"
                                                        id="scroll"
                                                        style={{
                                                            border: "1px solid #ccc",

                                                            padding: "5px 5px",
                                                            marginBottom: "15px",
                                                            overflow: "auto;",
                                                            display: "block;",
                                                            height: "333px",
                                                        }}
                                                    >
                                                        <ul
                                                            id="mf_list"
                                                            style={{
                                                                width: "100%",
                                                                padding: "5px",
                                                                listStyleType: "none",
                                                            }}
                                                        >
                                                            {itemsAlerts &&
                                                                itemsAlerts.map(
                                                                    (itemsAlert: any, index: number) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                type="checkbox"
                                                                                data-id={itemsAlert.id} // Utilisez data-id pour stocker l'identifiant
                                                                                onChange={handleCheckboxChange}
                                                                                checked={
                                                                                    checkboxStates[itemsAlert.value] ||
                                                                                    false
                                                                                } // Ajoutez une valeur par défaut (false) pour éviter des erreurs
                                                                                value={itemsAlert.value} // Pour transmettre la valeur liée
                                                                                name={itemsAlert.value} // Le name doit être unique par valeur
                                                                            />
                                                                            {itemsAlert.value}
                                                                        </div>
                                                                    )
                                                                )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-footer">
                                    <Link
                                        to={`/alarms`}
                                        className="btn btn-outline-secondary  mr-2"
                                        data-toggle="Cancel"
                                        data-placement="top"
                                        title="Cancel"
                                    >
                                        <i
                                            className="fas fa-chevron-left"
                                            style={{ fontSize: "1.2em" }}
                                        ></i>
                                        {translate("Cancel")}
                                    </Link>
                                    <button
                                        className={`btn btn-outline-secondary  mr-2 ${isCreateButtonDisabled ? "disabled" : ""
                                            }`}
                                        type="button"
                                        name="set_params"
                                        onClick={addAlarmParams}
                                    >
                                        <i className="fas fa-chevron-right"></i> {translate("Next")}
                                    </button>
                                </div>
                            </div>
                        )}
                        {step === 2 && (
                            <div
                                className="step-pane panel panel-default"
                                id="step2"
                                style={{
                                    marginTop: "5px",
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                }}
                            >
                                <div className="panel-body">
                                    <div
                                        className="row"
                                        id="criteria"
                                        style={{ display: "block" }}
                                    >
                                        <div
                                            className="col-md-12 col-sm-12"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <div className="input-group">
                                                <div
                                                    className="col-md-4 col-sm-3"
                                                    style={{ marginTop: "2px" }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        style={{ paddingRight: " 10px" }}
                                                    >
                                                        Alarme type:
                                                    </span>
                                                    <div className="input-group">
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className={`las la-bell  ${autocompleteStateIcon} icon-report`}
                                                                style={{ padding: "0px 5px" }}
                                                            />
                                                            <select
                                                                className="form-control input-sm"
                                                                value={selectedAlarm || "0"}
                                                                name="alarm_type"
                                                                onChange={(e) => {
                                                                    handleAlarmTypeChange(e.target.value);
                                                                }}
                                                            >
                                                                {alarmOptions
                                                                    .filter(option => {
                                                                        const alarmValue = Number(option.value);
                                                                        // on garde "-" ou les alarmes autorisées
                                                                        return (
                                                                            alarmValue === 0 ||
                                                                            userPermissions.some(
                                                                                perm => perm.id_permission === alarmValue + 86
                                                                            )
                                                                        );
                                                                    })
                                                                    .map(option => (
                                                                        <option key={option.value} value={option.value}>
                                                                            {translate(option.label)}
                                                                        </option>
                                                                    ))}

                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-md-4 col-sm-3"
                                                    style={{ marginTop: "2px" }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        style={{ paddingRight: " 10px" }}
                                                    >
                                                        {translate("Alarm name")}:
                                                    </span>
                                                    <div className="">
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className={`las la-edit ${autocompleteStateIcon} icon-report`}
                                                                style={{ padding: "0px 5px" }}
                                                            />
                                                            <input
                                                                className="form-control input-sm"
                                                                type="text"
                                                                name="alarm_name"
                                                                id="alarm_name"
                                                                placeholder="Name your alarm"
                                                                value={Alarm.alarm_name}
                                                                onInput={checkStep3}
                                                                onChange={(e) => {
                                                                    handleAlarmNameChange(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-md-4 col-sm-3"
                                                    style={{ marginTop: "2px" }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        style={{ paddingRight: " 10px" }}
                                                    >
                                                        {translate("Group alarm")}:{" "}
                                                    </span>
                                                    <div className="">
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className={`las la-users-cog ${autocompleteStateIcon} icon-report`}
                                                                style={{ padding: "0px 5px" }}
                                                            />
                                                            <Form.Control
                                                                type="text"
                                                                id="id_groupe_alarme"
                                                                placeholder={`${translate(
                                                                    "Set group of alarm"
                                                                )}`}
                                                                className="me-2 w-100"
                                                                aria-label={`${translate(
                                                                    InputAdvanceSearchGroup
                                                                )}`}
                                                                onChange={(e) => getGroupsAlarm(e.target.value)}
                                                                value={itemGroupSearch}
                                                                disabled={SelectGroupState}
                                                            />
                                                        </div>
                                                        <div
                                                            className={`autocomplete-items ${autocompleteGroupState}`}
                                                            style={{ listStyleType: "none", padding: 0 }}
                                                        >
                                                            {alarmSuggestions &&
                                                                alarmSuggestions.map(
                                                                    (alarmSuggestion: any, index: number) => (
                                                                        <div
                                                                            key={index}
                                                                            onClick={(e) => {
                                                                                handleAlarmGroupChange(alarmSuggestion);
                                                                            }}
                                                                        >
                                                                            <p> {alarmSuggestion.label}</p>
                                                                        </div>
                                                                    )
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="col-md-12 col-sm-12"
                                                style={{ margin: "30px 0" }}
                                            >
                                                {" "}
                                                {AlarmComponent}
                                            </div>
                                        </div>
                                        <div
                                            className="col-md-3 col-sm-3"
                                            id="opts_cell"
                                            style={{ display: "none", marginTop: "2px" }}
                                        ></div>
                                        <div
                                            className="col-md-3 col-sm-3"
                                            id="extra_cell_inline"
                                            style={{ display: "none", marginTop: "2px" }}
                                        ></div>
                                    </div>
                                    <div className="row" style={{ display: "none" }}>
                                        <div
                                            className="col-md-12"
                                            id="extra_cell"
                                            style={{ marginTop: "10px" }}
                                        ></div>
                                    </div>
                                </div>
                                <div className="panel-footer">
                                    <button
                                        className="btn btn-outline-secondary  mr-2"
                                        type="button"
                                        name="back"
                                        onClick={wizardBack}
                                    >
                                        <i
                                            className="fas fa-chevron-left"
                                            style={{ fontSize: "1.2em", color: "#ff7e41" }}
                                        ></i>{" "}
                                        {translate("Previous")}
                                    </button>
                                    <button
                                        className="btn btn-outline-secondary  mr-2"
                                        type="button"
                                        onClick={() => {
                                            setButtonClicked(true);

                                            id_alarme ? updateAlarm() : createAlarm();
                                        }}
                                        disabled={buttonClicked}
                                    >
                                        <i
                                            className="las la-bell"
                                            style={{ fontSize: "1.2em", color: "#ff7e41" }}
                                        ></i>
                                        {id_alarme
                                            ? translate("Update Alarm")
                                            : translate("Create Alarm")}
                                    </button>
                                </div>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </>
    );
};

export default Alarm;
